import { createReducer } from 'deox';

import {
  TChangePlayersBranchResponse,
  TCreatePlayerResponse,
  TDeletePlayerResponse,
  TGetChildPlayersResponse,
  TGetPlayerResponse,
  TGetPlayersInClassResponse,
  TGetPlayersResponse,
  TReactivePlayerResponse,
  TUpdatePlayerMemberCardResponse,
  TUpdatePlayerResponse,
} from '@/services/api/player';
import {
  changePlayersBranchAction,
  createPlayerAction,
  deletePlayerAction,
  getChildPlayersAction,
  getPlayerAction,
  getPlayersInClassAction,
  getPlayersAction,
  reactivePlayerAction,
  updatePlayerMemberCardAction,
  updatePlayerAction,
} from '@/redux/actions';
import { changePlayersBranchUpdateState } from './change-players-branch';
import { createPlayerUpdateState } from './create-player';
import { deletePlayerUpdateState } from './delete-player';
import { getChildPlayersUpdateState } from './get-child-players';
import { getPlayerUpdateState } from './get-player';
import { getPlayersInClassUpdateState } from './get-players-in-class';
import { getPlayersUpdateState } from './get-players';
import { reactivePlayerUpdateState } from './reactive-player';
import { updatePlayerMemberCardUpdateState } from './update-player-member-card';
import { updatePlayerUpdateState } from './update-player';

export type TPlayerState = {
  changePlayersBranchResponse?: TChangePlayersBranchResponse;
  createPlayerResponse?: TCreatePlayerResponse;
  deletePlayerResponse?: TDeletePlayerResponse;
  getChildPlayersResponse?: TGetChildPlayersResponse;
  getPlayerResponse?: TGetPlayerResponse;
  getPlayersInClassResponse?: TGetPlayersInClassResponse;
  getPlayersResponse?: TGetPlayersResponse;
  reactivePlayerResponse?: TReactivePlayerResponse;
  updatePlayerMemberCardResponse?: TUpdatePlayerMemberCardResponse;
  updatePlayerResponse?: TUpdatePlayerResponse;
};

const initialState: TPlayerState = {
  changePlayersBranchResponse: undefined,
  createPlayerResponse: undefined,
  deletePlayerResponse: undefined,
  getChildPlayersResponse: undefined,
  getPlayerResponse: undefined,
  getPlayersInClassResponse: undefined,
  getPlayersResponse: undefined,
  reactivePlayerResponse: undefined,
  updatePlayerMemberCardResponse: undefined,
  updatePlayerResponse: undefined,
};

const PlayerReducer = createReducer(initialState, (handleAction) => [
  handleAction(changePlayersBranchAction.success, changePlayersBranchUpdateState),
  handleAction(createPlayerAction.success, createPlayerUpdateState),
  handleAction(deletePlayerAction.success, deletePlayerUpdateState),
  handleAction(getChildPlayersAction.success, getChildPlayersUpdateState),
  handleAction(getPlayerAction.success, getPlayerUpdateState),
  handleAction(getPlayersInClassAction.success, getPlayersInClassUpdateState),
  handleAction(getPlayersAction.success, getPlayersUpdateState),
  handleAction(reactivePlayerAction.success, reactivePlayerUpdateState),
  handleAction(updatePlayerMemberCardAction.success, updatePlayerMemberCardUpdateState),
  handleAction(updatePlayerAction.success, updatePlayerUpdateState),
]);

export default PlayerReducer;
